import { Component, Input, OnInit,ViewChild,ElementRef } from '@angular/core';
import {DefaultEditor } from 'ng2-smart-table';

@Component({
  selector: 'app-select',
  template: `
  <nb-select [(ngModel)]="value" [disabled]="isDisabled" (selectedChange)="checkValue()">
    <nb-option value="male">{{ 'select-components.male' | translate }}</nb-option>
    <nb-option value="female">{{ 'select-components.female' | translate }}</nb-option>
    <nb-option value="other">{{ 'select-components.other' | translate }}</nb-option>
    </nb-select>
      
  `
})
export class SelectComponent extends DefaultEditor implements OnInit {
 
  @Input() value: any;
  @Input() rowData: any;

  isDisabled: boolean;
  constructor() { 
    super();
  }

  ngOnInit() {
    this.isDisabled=true;
    if(typeof this.cell!="undefined")
    {
      this.isDisabled=false;
      this.value=this.cell.newValue;
    }
  }

  checkValue()
  {
    this.cell.newValue=this.value;
  }


}